<ion-modal-header [title]="context.data.title"></ion-modal-header>

<section class="content">
  <tui-notification size="m" class="margin-y-md" [appearance]="context.data.type ?? 'error'"
    ><div>
      <p translate [translateParams]="context.data.params ?? {}" class="font-bold">{{ context.data.heading }}</p>
      <p translate [translateParams]="context.data.params ?? {}">{{ context.data.message }}</p>
    </div></tui-notification
  >
</section>

<ion-modal-footer>
  <button ion-id="app-notify-ok" ionButton size="m" (click)="ok()" appearance="cta">
    <span translate>GENERAL.OK</span>
  </button>
</ion-modal-footer>
